import React, { useState, useEffect } from "react";

// Material UI - Table
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid, Icon, useMediaQuery, useTheme } from "@mui/material";

import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import { StickyColumn, CustomCell } from "../../../../styles/GlobalStyle";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

import { Cell, CustomButtonV2, ClearIconButton, CustomTable, CustomTableHead, CustomToolbar, Forms, HeaderCell, SearchButton, TableContainer, TableContent, TableHeight } from "../../../../pages/styles";
import { ColorsContext } from "../../../../Context/ColorsContext"

// Utils
import { FormatDate } from "../../../../utils/formatDate";
import { useTranslation } from "react-i18next";

//Hooks
import { useSortByColumn } from "../../../../Hooks/useSortByColumn";

import {
  CustomTableCell,
  FigureHead,
  Text,
  Label,
  InputDate,
  CleanIcon,
  CleanButton,
  IconAction,
  NewIcon,
  ContainerInputsDate,
  ContainerContentHeader,
  ContainerSearch,
  ContainerGroup,
  CustomIconButton,
  CustomSearchIcon,
  CustomTableContainer,
} from "./style";

import {
  ContainerDates,
  ContainerFiltros,
} from "../TableModel/styles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const { mobile, tablet } = MediaQuerys;

const headCells = [
  {
    id: "createdAt",
    center: false,
    disablePadding: true,
    sortArrow: true,
    label: "system.logs.table.date",
    customSort: 'createdAt',
  },
  {
    id: "username",
    center: false,
    disablePadding: true,
    sortArrow: true,
    label: "system.logs.table.user",
    customSort: 'username',
  },
  {
    id: "module",
    center: false,
    disablePadding: true,
    sortArrow: true,
    label: "system.logs.table.module",
    customSort: 'module',
  },
  {
    id: "submodule",
    center: false,
    disablePadding: true,
    sortArrow: true,
    label: "system.logs.table.submodule",
    customSort: 'submodule',
  },
  {
    id: "action",
    center: false,
    disablePadding: true,
    sortArrow: true,
    label: "common.actions.title",
    customSort: 'action',
    sticky: true,
    direction: 'right',
  },
];

// Cabecera de la tablaaaaa

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
	const { t } = useTranslation();
  const { colors } = React.useContext(ColorsContext);

  const createSortHandler = (property, customSort) => (event) => {
    onRequestSort(event, property, customSort);
  };

  return (
    <CustomTableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <HeaderCell
            key={headCell.id}
            align={headCell.center ? "center" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            dataHead={headCell}
          >
            {headCell.sortArrow == true && (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id, headCell.customSort)}
              >
                {t(headCell.label) || headCell.label}
                {orderBy === headCell.id ? <Box sx={{ position: 'unset' }} component="span"></Box> : null}
              </TableSortLabel>
            )}
            {headCell.sortArrow == false && (
              <>
                <Box sx={{ position: 'unset' }} component="span">{t(headCell.label) || headCell.label}</Box>
              </>
            )}
          </HeaderCell>
        ))}
      </TableRow>
    </CustomTableHead>
  );
}

const EnhancedTableToolbar = (props) => {
	const { t } = useTranslation();
  const { colors } = React.useContext(ColorsContext);

  const { handleDatesFilter, handleClearDate, handleDownloadExcel, arrayLogs } = props;

  return (
    <CustomToolbar sx={{ mt: { xs: 2, sm: 1, md: 1 } }}>
      <Forms onSubmit={handleDatesFilter} style={{ justifyContent: 'flex-start', width: '100%' }}>
        <ContainerFiltros style={{ width: '100%' }}>
          <ContainerDates sx={{ 
             width: '100%', 
             flexDirection: { xs: 'column', sm: 'row' },
             alignItems: { xs: 'flex-start', sm: 'center' },
             gap: { xs: 1, md: 1 } 
          }}>
            <ContainerGroup sx={{ width: { xs: '100%', sm: 'auto' } }}>
              <ContainerInputsDate>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                  <DatePicker
                    label={t("common.initDate")}
                    value={moment(props?.initialDate)}
                    minDate={moment('2020-03-20')}
                    maxDate={moment(props?.finalDate)}
                    onChange={(newValue) => {
                      if (newValue && newValue.isValid()) {
                        props.setInitialDate(newValue.format('YYYY-MM-DD'));
                      }
                    }}
                    slotProps={{ textField: { size: 'small', error: false, sx: { minWidth: '100%', width: '100%' } } }}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </ContainerInputsDate>

              <ContainerInputsDate>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                  <DatePicker
                    label={t("common.lastDate")}
                    value={moment(props?.finalDate)}
                    minDate={moment(props?.initialDate)}
                    maxDate={moment(props?.finalDate)}
                    onChange={(newValue) => {
                      if (newValue && newValue.isValid()) {
                        props.setFinalDate(newValue.format('YYYY-MM-DD'));
                      }
                    }}
                    slotProps={{ textField: { size: 'small', error: false, sx: { minWidth: '100%', width: '100%' } } }}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </ContainerInputsDate>
            </ContainerGroup>

            <ContainerSearch sx={{ 
                width: { xs: '100%', sm: 'auto' }, 
                gap: '4px', 
            }}>
              <CustomButtonV2 
                variant="contained"
                btnType="primary"
                type="submit"
                startIcon={<SearchIcon />}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                {t("common.search")}
              </CustomButtonV2>
              <CleanButton
                startIcon={<CleanIcon />}
                onClick={handleClearDate}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                {t("common.clean")}
              </CleanButton>
            </ContainerSearch>
          </ContainerDates>
        </ContainerFiltros>
      </Forms>
    </CustomToolbar>
  );
};


export const TableLogs = ({
  arrayLogs,
  setArrayLogs,
  rows,
  setRows,

  initialDate,
  setInitialDate,
  finalDate,
  setFinalDate,

  handleDatesFilter,
  handleClearDate,
}) => {

	const { t } = useTranslation();
  const { format } = new FormatDate()
  const { colors } = React.useContext(ColorsContext);
    
    const theme = useTheme();
    const isDesktopOrSmaller = useMediaQuery(theme.breakpoints.down('lg'));

  const { order, orderBy, stableSort, getComparator, handleRequestSort } = useSortByColumn('createdAt');

  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Box sx={{ width: "100%" }}>
      <EnhancedTableToolbar
        initialDate={initialDate}
        setInitialDate={setInitialDate}
        finalDate={finalDate}
        setFinalDate={setFinalDate}
        arrayLogs={arrayLogs}
        handleDatesFilter={handleDatesFilter}
        handleClearDate={handleClearDate}
      />
      <TableContainer>

        <TableHeight isManagement={isDesktopOrSmaller ?? false}
          sx={{ height: { md: 'calc(100vh - 320px)', lg: 'calc(100vh - 280px)' } }}>
          <CustomTable
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableContent>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                    rows.sort(getComparator(order, orderBy)).slice() */}
              {stableSort(arrayLogs, getComparator())
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={row.id}>
                      <Cell
                        component="th"
                        scope="row"
                        sx={{ border: "none", fontSize: "0.75rem" }}
                      >
                        {format({ date: row.createdAt, format: true })}
                      </Cell>
                      <Cell sx={{ border: "none" }}>
                        {row.username}
                      </Cell>
                      <Cell sx={{ border: "none" }}>
                        {row.module}
                      </Cell>
                      <Cell sx={{ border: "none" }}>
                        {row.submodule}
                      </Cell>
                      <Cell direction='right'>
                        {row.action}
                      </Cell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <Cell colSpan={6} />
                </TableRow>
              )}
            </TableContent>
          </CustomTable>
        </TableHeight>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          showFirstButton
          showLastButton
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={t("common.itemsPerPage")}
          labelDisplayedRows={({ from, to, count }) => {
            return "" + from + "-" + to + ` ${t("common.of")} ` + count;
          }}
          sx={{
            borderTop: "1px solid " + colors.gray,
          }}
        />
      </TableContainer>
    </Box>
  );
};
